// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2f6b7cf9","501":"1e71333e"}[chunkId] + ".chunk.js";
};